import type { MantineNumberSize } from '@mantine/core';

export const spacing: Record<MantineNumberSize, number> = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
};
